var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 27,
    viewBox: "0 0 14 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H10.1818C8.49408 0 6.87546 0.711159 5.68205 1.97703C4.48863 3.2429 3.81818 4.95979 3.81818 6.75V10.8H0V16.2H3.81818V27H8.90909V16.2H12.7273L14 10.8H8.90909V6.75C8.90909 6.39196 9.04318 6.04858 9.28186 5.79541C9.52055 5.54223 9.84427 5.4 10.1818 5.4H14V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooter);
export default __webpack_public_path__ + "static/media/facebook-footer.7f6fef371581423103e77a7b61b1c64f.svg";
export { ForwardRef as ReactComponent };